export enum EConnectionType {
  EthWallet = 'eth-wallet',
  MatchId = 'match-id',
}

/**
 * The name of the parameter in the address bar, which stores the wallet id
 * for connecting to the wallet via deep linking.
 */
export const WALLET_PARAM = 'wallet';

export const DEFAULT_CONNECTION_KEY = 'unauthorized-key';
